function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { AvailabilityFilter } from './availability';
import { BadgesFilter } from './badges';
import { BathroomsFilter } from './bathrooms';
import { BedsFilter } from './bedrooms';
import { BlockSizeFilter } from './block-size';
import { FloorAreaFilter } from './floor-area';
import { KeywordsFilter } from './keywords';
import { ListedDateFilter } from './listed-date';
import { ListedPropertyTypesFilter } from './listed-property-types';
import { ListingFeaturesFilter } from './listing-features';
import { OnlyWithEventsFilter } from './only-with-events';
import { OnlyWithPriceFilter } from './only-with-price';
import { ParkingFilter } from './parking';
import { PriceFilter } from './price';
import { PropertyStatusFilter } from './property-status';
import { PropertyTypesFilter } from './property-types';
import { SaleMethodsFilter } from './sale-methods';
var FilterTypeMap = {
  price: PriceFilter,
  beds: BedsFilter,
  baths: BathroomsFilter,
  parking: ParkingFilter,
  floorArea: FloorAreaFilter,
  blockSize: BlockSizeFilter,
  availability: AvailabilityFilter,
  listedDate: ListedDateFilter,
  keywords: KeywordsFilter,
  onlyWithPrice: OnlyWithPriceFilter,
  onlyWithEvents: OnlyWithEventsFilter,
  propertyTypes: PropertyTypesFilter,
  propertyStatus: PropertyStatusFilter,
  saleMethods: SaleMethodsFilter,
  listingFeatures: ListingFeaturesFilter,
  listedPropertyTypes: ListedPropertyTypesFilter,
  badges: BadgesFilter
};
export var FilterTypes = Object.keys(FilterTypeMap);
export var FilterType = Object.fromEntries(Object.entries(FilterTypeMap).map(_ref => {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    value = _ref2[1];
  return [key, {
    name: key,
    urlSlug: value.urlSlug
  }];
}));